import React, { useEffect, useState } from 'react';
import { getClaimValue } from '../adios';

const IconUserInitials = ({ isHighlighted, handleClick, approvalModule }) => {
    const [isFocused, setIsFocused] = useState(false);
    const [inactiveColor, setInactiveColor] = useState('#414141');

    useEffect(() => {
        if (approvalModule != null) {
            if (approvalModule.shortCode === 'ARS' && approvalModule.approvalRequests > 0) {
                setInactiveColor('#1101BE');
            } else if (approvalModule.shortCode === 'ARR' && approvalModule.approvalRequests > 0) {
                setInactiveColor('#D90000');
            }
        }
    }, [approvalModule]);

    const initialsStyle = {
        fill: '#FFFFFF',
        fontFamily: 'Roboto',
        fontSize: 18,
        fontWeight: 500,
        textAlign: 'center'
    };

    return (
        <svg
            width={40}
            height={40}
            onClick={handleClick}
            style={{ cursor: 'pointer' }}
            onMouseEnter={() => setIsFocused(true)}
            onMouseLeave={() => setIsFocused(false)}
        >
            <circle
                r={20}
                cy={20}
                cx={20}
                fill={isHighlighted || isFocused ? '#FAA800' : inactiveColor}
            />
            <text x={20} y={27} style={initialsStyle} textAnchor='middle'>
                {getClaimValue('initials')}
            </text>
        </svg>
    );
};

export default IconUserInitials;
